/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as OrganizationSlugIndexRouteImport } from './routes/$organizationSlug/index'
import { Route as OrganizationSlugBlueprintsSplatRouteImport } from './routes/$organizationSlug/blueprints/$'
import { Route as OrganizationSlugBranchesBranchIdRouteRouteImport } from './routes/$organizationSlug/branches/$branchId/route'
import { Route as OrganizationSlugCharactersIndexRouteImport } from './routes/$organizationSlug/characters/index'
import { Route as OrganizationSlugEventsIndexRouteImport } from './routes/$organizationSlug/events/index'
import { Route as OrganizationSlugEventsEventIdRouteRouteImport } from './routes/$organizationSlug/events/$eventId/route'
import { Route as OrganizationSlugInvoiceIndexRouteImport } from './routes/$organizationSlug/invoice/index'
import { Route as OrganizationSlugPlayersPlayerIdRouteRouteImport } from './routes/$organizationSlug/players/$playerId/route'
import { Route as OrganizationSlugReportsIndexRouteImport } from './routes/$organizationSlug/reports/index'
import { Route as OrganizationSlugStatisticsSplatRouteImport } from './routes/$organizationSlug/statistics/$'
import { Route as OrganizationSlugBlueprintsTabularIndexRouteImport } from './routes/$organizationSlug/blueprints/tabular/index'
import { Route as OrganizationSlugBranchesBranchIdIndexRouteImport } from './routes/$organizationSlug/branches/$branchId/index'
import { Route as OrganizationSlugBranchesBranchIdSplatRouteImport } from './routes/$organizationSlug/branches/$branchId/$'
import { Route as OrganizationSlugBranchesBranchIdAttendanceRouteImport } from './routes/$organizationSlug/branches/$branchId/attendance'
import { Route as OrganizationSlugBranchesBranchIdCapsRouteImport } from './routes/$organizationSlug/branches/$branchId/caps'
import { Route as OrganizationSlugBranchesBranchIdContractsRouteImport } from './routes/$organizationSlug/branches/$branchId/contracts'
import { Route as OrganizationSlugBranchesBranchIdCorrective_actionsRouteImport } from './routes/$organizationSlug/branches/$branchId/corrective_actions'
import { Route as OrganizationSlugBranchesBranchIdLocationsRouteImport } from './routes/$organizationSlug/branches/$branchId/locations'
import { Route as OrganizationSlugEventsEventIdIndexRouteImport } from './routes/$organizationSlug/events/$eventId/index'
import { Route as OrganizationSlugEventsEventIdSplatRouteImport } from './routes/$organizationSlug/events/$eventId/$'
import { Route as OrganizationSlugEventsEventIdBasicsRouteImport } from './routes/$organizationSlug/events/$eventId/basics'
import { Route as OrganizationSlugEventsEventIdCheckoutRouteImport } from './routes/$organizationSlug/events/$eventId/checkout'
import { Route as OrganizationSlugEventsEventIdLogisticsRouteImport } from './routes/$organizationSlug/events/$eventId/logistics'
import { Route as OrganizationSlugEventsEventIdPrintLedgerRouteImport } from './routes/$organizationSlug/events/$eventId/printLedger'
import { Route as OrganizationSlugEventsEventIdPrintoutsRouteImport } from './routes/$organizationSlug/events/$eventId/printouts'
import { Route as OrganizationSlugEventsEventIdSheetsRouteImport } from './routes/$organizationSlug/events/$eventId/sheets'
import { Route as OrganizationSlugEventsEventIdShiftsRouteImport } from './routes/$organizationSlug/events/$eventId/shifts'
import { Route as OrganizationSlugEventsEventIdTicketsRouteImport } from './routes/$organizationSlug/events/$eventId/tickets'
import { Route as OrganizationSlugEventsEventIdTransactions_auditRouteImport } from './routes/$organizationSlug/events/$eventId/transactions_audit'
import { Route as OrganizationSlugEventsEventIdWar_roomRouteImport } from './routes/$organizationSlug/events/$eventId/war_room'
import { Route as OrganizationSlugMechanicsDice_rollerIndexRouteImport } from './routes/$organizationSlug/mechanics/dice_roller/index'
import { Route as OrganizationSlugMechanicsDiseasesSplatRouteImport } from './routes/$organizationSlug/mechanics/diseases/$'
import { Route as OrganizationSlugMechanicsFaithsSplatRouteImport } from './routes/$organizationSlug/mechanics/faiths/$'
import { Route as OrganizationSlugMechanicsSocietiesSplatRouteImport } from './routes/$organizationSlug/mechanics/societies/$'
import { Route as OrganizationSlugMechanicsThreatsSplatRouteImport } from './routes/$organizationSlug/mechanics/threats/$'
import { Route as OrganizationSlugPlayersPlayerIdIndexRouteImport } from './routes/$organizationSlug/players/$playerId/index'
import { Route as OrganizationSlugPlayersPlayerIdSplatRouteImport } from './routes/$organizationSlug/players/$playerId/$'
import { Route as OrganizationSlugPlayersPlayerIdAttendanceRouteImport } from './routes/$organizationSlug/players/$playerId/attendance'
import { Route as OrganizationSlugPlayersPlayerIdCorrective_actionsRouteImport } from './routes/$organizationSlug/players/$playerId/corrective_actions'
import { Route as OrganizationSlugPlayersPlayerIdMembershipsRouteImport } from './routes/$organizationSlug/players/$playerId/memberships'
import { Route as OrganizationSlugPlayersPlayerIdPerksRouteImport } from './routes/$organizationSlug/players/$playerId/perks'
import { Route as OrganizationSlugPlayersPlayerIdReferralsRouteImport } from './routes/$organizationSlug/players/$playerId/referrals'
import { Route as OrganizationSlugReportsCapsIndexRouteImport } from './routes/$organizationSlug/reports/caps/index'
import { Route as OrganizationSlugReportsCapsBranchIdRouteImport } from './routes/$organizationSlug/reports/caps/$branchId'
import { Route as OrganizationSlugReportsCharacter_retirementsIndexRouteImport } from './routes/$organizationSlug/reports/character_retirements/index'
import { Route as OrganizationSlugReportsCorrective_actionsIndexRouteImport } from './routes/$organizationSlug/reports/corrective_actions/index'
import { Route as OrganizationSlugReportsCorrective_actionsBranchIdRouteImport } from './routes/$organizationSlug/reports/corrective_actions/$branchId'
import { Route as OrganizationSlugReportsGrowthIndexRouteImport } from './routes/$organizationSlug/reports/growth/index'
import { Route as OrganizationSlugReportsMembershipsIndexRouteImport } from './routes/$organizationSlug/reports/memberships/index'
import { Route as OrganizationSlugReportsPlayersIndexRouteImport } from './routes/$organizationSlug/reports/players/index'
import { Route as OrganizationSlugSettingsSpecial_datesIndexRouteImport } from './routes/$organizationSlug/settings/special_dates/index'
import { Route as OrganizationSlugEventsEventIdBlueprintsSplatRouteImport } from './routes/$organizationSlug/events/$eventId/blueprints/$'
import { Route as OrganizationSlugEventsEventIdModsIndexRouteImport } from './routes/$organizationSlug/events/$eventId/mods/index'
import { Route as OrganizationSlugEventsEventIdModsModIdRouteRouteImport } from './routes/$organizationSlug/events/$eventId/mods/$modId/route'
import { Route as OrganizationSlugPlayersPlayerIdCharactersIndexRouteImport } from './routes/$organizationSlug/players/$playerId/characters/index'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/route'
import { Route as OrganizationSlugEventsEventIdModsModIdIndexRouteImport } from './routes/$organizationSlug/events/$eventId/mods/$modId/index'
import { Route as OrganizationSlugEventsEventIdModsModIdBattlefieldRouteImport } from './routes/$organizationSlug/events/$eventId/mods/$modId/battlefield'
import { Route as OrganizationSlugEventsEventIdModsModIdRewardsRouteImport } from './routes/$organizationSlug/events/$eventId/mods/$modId/rewards'
import { Route as OrganizationSlugEventsEventIdModsModIdStorytellerRouteImport } from './routes/$organizationSlug/events/$eventId/mods/$modId/storyteller'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/index'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/$'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/inventory'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/journal'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/printout'
import { Route as OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRouteImport } from './routes/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationSlugIndexRoute = OrganizationSlugIndexRouteImport.update({
  id: '/$organizationSlug/',
  path: '/$organizationSlug/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationSlugBlueprintsSplatRoute =
  OrganizationSlugBlueprintsSplatRouteImport.update({
    id: '/$organizationSlug/blueprints/$',
    path: '/$organizationSlug/blueprints/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugBranchesBranchIdRouteRoute =
  OrganizationSlugBranchesBranchIdRouteRouteImport.update({
    id: '/$organizationSlug/branches/$branchId',
    path: '/$organizationSlug/branches/$branchId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugCharactersIndexRoute =
  OrganizationSlugCharactersIndexRouteImport.update({
    id: '/$organizationSlug/characters/',
    path: '/$organizationSlug/characters/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugEventsIndexRoute =
  OrganizationSlugEventsIndexRouteImport.update({
    id: '/$organizationSlug/events/',
    path: '/$organizationSlug/events/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugEventsEventIdRouteRoute =
  OrganizationSlugEventsEventIdRouteRouteImport.update({
    id: '/$organizationSlug/events/$eventId',
    path: '/$organizationSlug/events/$eventId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugInvoiceIndexRoute =
  OrganizationSlugInvoiceIndexRouteImport.update({
    id: '/$organizationSlug/invoice/',
    path: '/$organizationSlug/invoice/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugPlayersPlayerIdRouteRoute =
  OrganizationSlugPlayersPlayerIdRouteRouteImport.update({
    id: '/$organizationSlug/players/$playerId',
    path: '/$organizationSlug/players/$playerId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsIndexRoute =
  OrganizationSlugReportsIndexRouteImport.update({
    id: '/$organizationSlug/reports/',
    path: '/$organizationSlug/reports/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugStatisticsSplatRoute =
  OrganizationSlugStatisticsSplatRouteImport.update({
    id: '/$organizationSlug/statistics/$',
    path: '/$organizationSlug/statistics/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugBlueprintsTabularIndexRoute =
  OrganizationSlugBlueprintsTabularIndexRouteImport.update({
    id: '/$organizationSlug/blueprints/tabular/',
    path: '/$organizationSlug/blueprints/tabular/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugBranchesBranchIdIndexRoute =
  OrganizationSlugBranchesBranchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdSplatRoute =
  OrganizationSlugBranchesBranchIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdAttendanceRoute =
  OrganizationSlugBranchesBranchIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdCapsRoute =
  OrganizationSlugBranchesBranchIdCapsRouteImport.update({
    id: '/caps',
    path: '/caps',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdContractsRoute =
  OrganizationSlugBranchesBranchIdContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdCorrective_actionsRoute =
  OrganizationSlugBranchesBranchIdCorrective_actionsRouteImport.update({
    id: '/corrective_actions',
    path: '/corrective_actions',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugBranchesBranchIdLocationsRoute =
  OrganizationSlugBranchesBranchIdLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => OrganizationSlugBranchesBranchIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdIndexRoute =
  OrganizationSlugEventsEventIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdSplatRoute =
  OrganizationSlugEventsEventIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdBasicsRoute =
  OrganizationSlugEventsEventIdBasicsRouteImport.update({
    id: '/basics',
    path: '/basics',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdCheckoutRoute =
  OrganizationSlugEventsEventIdCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdLogisticsRoute =
  OrganizationSlugEventsEventIdLogisticsRouteImport.update({
    id: '/logistics',
    path: '/logistics',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdPrintLedgerRoute =
  OrganizationSlugEventsEventIdPrintLedgerRouteImport.update({
    id: '/printLedger',
    path: '/printLedger',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdPrintoutsRoute =
  OrganizationSlugEventsEventIdPrintoutsRouteImport.update({
    id: '/printouts',
    path: '/printouts',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdSheetsRoute =
  OrganizationSlugEventsEventIdSheetsRouteImport.update({
    id: '/sheets',
    path: '/sheets',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdShiftsRoute =
  OrganizationSlugEventsEventIdShiftsRouteImport.update({
    id: '/shifts',
    path: '/shifts',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdTicketsRoute =
  OrganizationSlugEventsEventIdTicketsRouteImport.update({
    id: '/tickets',
    path: '/tickets',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdTransactions_auditRoute =
  OrganizationSlugEventsEventIdTransactions_auditRouteImport.update({
    id: '/transactions_audit',
    path: '/transactions_audit',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdWar_roomRoute =
  OrganizationSlugEventsEventIdWar_roomRouteImport.update({
    id: '/war_room',
    path: '/war_room',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugMechanicsDice_rollerIndexRoute =
  OrganizationSlugMechanicsDice_rollerIndexRouteImport.update({
    id: '/$organizationSlug/mechanics/dice_roller/',
    path: '/$organizationSlug/mechanics/dice_roller/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugMechanicsDiseasesSplatRoute =
  OrganizationSlugMechanicsDiseasesSplatRouteImport.update({
    id: '/$organizationSlug/mechanics/diseases/$',
    path: '/$organizationSlug/mechanics/diseases/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugMechanicsFaithsSplatRoute =
  OrganizationSlugMechanicsFaithsSplatRouteImport.update({
    id: '/$organizationSlug/mechanics/faiths/$',
    path: '/$organizationSlug/mechanics/faiths/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugMechanicsSocietiesSplatRoute =
  OrganizationSlugMechanicsSocietiesSplatRouteImport.update({
    id: '/$organizationSlug/mechanics/societies/$',
    path: '/$organizationSlug/mechanics/societies/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugMechanicsThreatsSplatRoute =
  OrganizationSlugMechanicsThreatsSplatRouteImport.update({
    id: '/$organizationSlug/mechanics/threats/$',
    path: '/$organizationSlug/mechanics/threats/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugPlayersPlayerIdIndexRoute =
  OrganizationSlugPlayersPlayerIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdSplatRoute =
  OrganizationSlugPlayersPlayerIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdAttendanceRoute =
  OrganizationSlugPlayersPlayerIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCorrective_actionsRoute =
  OrganizationSlugPlayersPlayerIdCorrective_actionsRouteImport.update({
    id: '/corrective_actions',
    path: '/corrective_actions',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdMembershipsRoute =
  OrganizationSlugPlayersPlayerIdMembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdPerksRoute =
  OrganizationSlugPlayersPlayerIdPerksRouteImport.update({
    id: '/perks',
    path: '/perks',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdReferralsRoute =
  OrganizationSlugPlayersPlayerIdReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugReportsCapsIndexRoute =
  OrganizationSlugReportsCapsIndexRouteImport.update({
    id: '/$organizationSlug/reports/caps/',
    path: '/$organizationSlug/reports/caps/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsCapsBranchIdRoute =
  OrganizationSlugReportsCapsBranchIdRouteImport.update({
    id: '/$organizationSlug/reports/caps/$branchId',
    path: '/$organizationSlug/reports/caps/$branchId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsCharacter_retirementsIndexRoute =
  OrganizationSlugReportsCharacter_retirementsIndexRouteImport.update({
    id: '/$organizationSlug/reports/character_retirements/',
    path: '/$organizationSlug/reports/character_retirements/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsCorrective_actionsIndexRoute =
  OrganizationSlugReportsCorrective_actionsIndexRouteImport.update({
    id: '/$organizationSlug/reports/corrective_actions/',
    path: '/$organizationSlug/reports/corrective_actions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsCorrective_actionsBranchIdRoute =
  OrganizationSlugReportsCorrective_actionsBranchIdRouteImport.update({
    id: '/$organizationSlug/reports/corrective_actions/$branchId',
    path: '/$organizationSlug/reports/corrective_actions/$branchId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsGrowthIndexRoute =
  OrganizationSlugReportsGrowthIndexRouteImport.update({
    id: '/$organizationSlug/reports/growth/',
    path: '/$organizationSlug/reports/growth/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsMembershipsIndexRoute =
  OrganizationSlugReportsMembershipsIndexRouteImport.update({
    id: '/$organizationSlug/reports/memberships/',
    path: '/$organizationSlug/reports/memberships/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugReportsPlayersIndexRoute =
  OrganizationSlugReportsPlayersIndexRouteImport.update({
    id: '/$organizationSlug/reports/players/',
    path: '/$organizationSlug/reports/players/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugSettingsSpecial_datesIndexRoute =
  OrganizationSlugSettingsSpecial_datesIndexRouteImport.update({
    id: '/$organizationSlug/settings/special_dates/',
    path: '/$organizationSlug/settings/special_dates/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationSlugEventsEventIdBlueprintsSplatRoute =
  OrganizationSlugEventsEventIdBlueprintsSplatRouteImport.update({
    id: '/blueprints/$',
    path: '/blueprints/$',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsIndexRoute =
  OrganizationSlugEventsEventIdModsIndexRouteImport.update({
    id: '/mods/',
    path: '/mods/',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsModIdRouteRoute =
  OrganizationSlugEventsEventIdModsModIdRouteRouteImport.update({
    id: '/mods/$modId',
    path: '/mods/$modId',
    getParentRoute: () => OrganizationSlugEventsEventIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCharactersIndexRoute =
  OrganizationSlugPlayersPlayerIdCharactersIndexRouteImport.update({
    id: '/characters/',
    path: '/characters/',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteImport.update({
    id: '/characters/$characterId',
    path: '/characters/$characterId',
    getParentRoute: () => OrganizationSlugPlayersPlayerIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsModIdIndexRoute =
  OrganizationSlugEventsEventIdModsModIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationSlugEventsEventIdModsModIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsModIdBattlefieldRoute =
  OrganizationSlugEventsEventIdModsModIdBattlefieldRouteImport.update({
    id: '/battlefield',
    path: '/battlefield',
    getParentRoute: () => OrganizationSlugEventsEventIdModsModIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsModIdRewardsRoute =
  OrganizationSlugEventsEventIdModsModIdRewardsRouteImport.update({
    id: '/rewards',
    path: '/rewards',
    getParentRoute: () => OrganizationSlugEventsEventIdModsModIdRouteRoute,
  } as any)
const OrganizationSlugEventsEventIdModsModIdStorytellerRoute =
  OrganizationSlugEventsEventIdModsModIdStorytellerRouteImport.update({
    id: '/storyteller',
    path: '/storyteller',
    getParentRoute: () => OrganizationSlugEventsEventIdModsModIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () =>
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
  } as any)
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRouteImport.update(
    {
      id: '/inventory',
      path: '/inventory',
      getParentRoute: () =>
        OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
    } as any,
  )
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRouteImport.update(
    {
      id: '/journal',
      path: '/journal',
      getParentRoute: () =>
        OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
    } as any,
  )
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRouteImport.update(
    {
      id: '/printout',
      path: '/printout',
      getParentRoute: () =>
        OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
    } as any,
  )
const OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRouteImport.update(
    {
      id: '/xp_audit',
      path: '/xp_audit',
      getParentRoute: () =>
        OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/$organizationSlug/': typeof OrganizationSlugIndexRoute
  '/$organizationSlug/branches/$branchId': typeof OrganizationSlugBranchesBranchIdRouteRouteWithChildren
  '/$organizationSlug/events/$eventId': typeof OrganizationSlugEventsEventIdRouteRouteWithChildren
  '/$organizationSlug/players/$playerId': typeof OrganizationSlugPlayersPlayerIdRouteRouteWithChildren
  '/$organizationSlug/blueprints/$': typeof OrganizationSlugBlueprintsSplatRoute
  '/$organizationSlug/statistics/$': typeof OrganizationSlugStatisticsSplatRoute
  '/$organizationSlug/characters/': typeof OrganizationSlugCharactersIndexRoute
  '/$organizationSlug/events/': typeof OrganizationSlugEventsIndexRoute
  '/$organizationSlug/invoice/': typeof OrganizationSlugInvoiceIndexRoute
  '/$organizationSlug/reports/': typeof OrganizationSlugReportsIndexRoute
  '/$organizationSlug/branches/$branchId/$': typeof OrganizationSlugBranchesBranchIdSplatRoute
  '/$organizationSlug/branches/$branchId/attendance': typeof OrganizationSlugBranchesBranchIdAttendanceRoute
  '/$organizationSlug/branches/$branchId/caps': typeof OrganizationSlugBranchesBranchIdCapsRoute
  '/$organizationSlug/branches/$branchId/contracts': typeof OrganizationSlugBranchesBranchIdContractsRoute
  '/$organizationSlug/branches/$branchId/corrective_actions': typeof OrganizationSlugBranchesBranchIdCorrective_actionsRoute
  '/$organizationSlug/branches/$branchId/locations': typeof OrganizationSlugBranchesBranchIdLocationsRoute
  '/$organizationSlug/events/$eventId/$': typeof OrganizationSlugEventsEventIdSplatRoute
  '/$organizationSlug/events/$eventId/basics': typeof OrganizationSlugEventsEventIdBasicsRoute
  '/$organizationSlug/events/$eventId/checkout': typeof OrganizationSlugEventsEventIdCheckoutRoute
  '/$organizationSlug/events/$eventId/logistics': typeof OrganizationSlugEventsEventIdLogisticsRoute
  '/$organizationSlug/events/$eventId/printLedger': typeof OrganizationSlugEventsEventIdPrintLedgerRoute
  '/$organizationSlug/events/$eventId/printouts': typeof OrganizationSlugEventsEventIdPrintoutsRoute
  '/$organizationSlug/events/$eventId/sheets': typeof OrganizationSlugEventsEventIdSheetsRoute
  '/$organizationSlug/events/$eventId/shifts': typeof OrganizationSlugEventsEventIdShiftsRoute
  '/$organizationSlug/events/$eventId/tickets': typeof OrganizationSlugEventsEventIdTicketsRoute
  '/$organizationSlug/events/$eventId/transactions_audit': typeof OrganizationSlugEventsEventIdTransactions_auditRoute
  '/$organizationSlug/events/$eventId/war_room': typeof OrganizationSlugEventsEventIdWar_roomRoute
  '/$organizationSlug/mechanics/diseases/$': typeof OrganizationSlugMechanicsDiseasesSplatRoute
  '/$organizationSlug/mechanics/faiths/$': typeof OrganizationSlugMechanicsFaithsSplatRoute
  '/$organizationSlug/mechanics/societies/$': typeof OrganizationSlugMechanicsSocietiesSplatRoute
  '/$organizationSlug/mechanics/threats/$': typeof OrganizationSlugMechanicsThreatsSplatRoute
  '/$organizationSlug/players/$playerId/$': typeof OrganizationSlugPlayersPlayerIdSplatRoute
  '/$organizationSlug/players/$playerId/attendance': typeof OrganizationSlugPlayersPlayerIdAttendanceRoute
  '/$organizationSlug/players/$playerId/corrective_actions': typeof OrganizationSlugPlayersPlayerIdCorrective_actionsRoute
  '/$organizationSlug/players/$playerId/memberships': typeof OrganizationSlugPlayersPlayerIdMembershipsRoute
  '/$organizationSlug/players/$playerId/perks': typeof OrganizationSlugPlayersPlayerIdPerksRoute
  '/$organizationSlug/players/$playerId/referrals': typeof OrganizationSlugPlayersPlayerIdReferralsRoute
  '/$organizationSlug/reports/caps/$branchId': typeof OrganizationSlugReportsCapsBranchIdRoute
  '/$organizationSlug/reports/corrective_actions/$branchId': typeof OrganizationSlugReportsCorrective_actionsBranchIdRoute
  '/$organizationSlug/blueprints/tabular/': typeof OrganizationSlugBlueprintsTabularIndexRoute
  '/$organizationSlug/branches/$branchId/': typeof OrganizationSlugBranchesBranchIdIndexRoute
  '/$organizationSlug/events/$eventId/': typeof OrganizationSlugEventsEventIdIndexRoute
  '/$organizationSlug/mechanics/dice_roller/': typeof OrganizationSlugMechanicsDice_rollerIndexRoute
  '/$organizationSlug/players/$playerId/': typeof OrganizationSlugPlayersPlayerIdIndexRoute
  '/$organizationSlug/reports/caps/': typeof OrganizationSlugReportsCapsIndexRoute
  '/$organizationSlug/reports/character_retirements/': typeof OrganizationSlugReportsCharacter_retirementsIndexRoute
  '/$organizationSlug/reports/corrective_actions/': typeof OrganizationSlugReportsCorrective_actionsIndexRoute
  '/$organizationSlug/reports/growth/': typeof OrganizationSlugReportsGrowthIndexRoute
  '/$organizationSlug/reports/memberships/': typeof OrganizationSlugReportsMembershipsIndexRoute
  '/$organizationSlug/reports/players/': typeof OrganizationSlugReportsPlayersIndexRoute
  '/$organizationSlug/settings/special_dates/': typeof OrganizationSlugSettingsSpecial_datesIndexRoute
  '/$organizationSlug/events/$eventId/mods/$modId': typeof OrganizationSlugEventsEventIdModsModIdRouteRouteWithChildren
  '/$organizationSlug/players/$playerId/characters/$characterId': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteWithChildren
  '/$organizationSlug/events/$eventId/blueprints/$': typeof OrganizationSlugEventsEventIdBlueprintsSplatRoute
  '/$organizationSlug/events/$eventId/mods/': typeof OrganizationSlugEventsEventIdModsIndexRoute
  '/$organizationSlug/players/$playerId/characters/': typeof OrganizationSlugPlayersPlayerIdCharactersIndexRoute
  '/$organizationSlug/events/$eventId/mods/$modId/battlefield': typeof OrganizationSlugEventsEventIdModsModIdBattlefieldRoute
  '/$organizationSlug/events/$eventId/mods/$modId/rewards': typeof OrganizationSlugEventsEventIdModsModIdRewardsRoute
  '/$organizationSlug/events/$eventId/mods/$modId/storyteller': typeof OrganizationSlugEventsEventIdModsModIdStorytellerRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/$': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/inventory': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/journal': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/printout': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute
  '/$organizationSlug/events/$eventId/mods/$modId/': typeof OrganizationSlugEventsEventIdModsModIdIndexRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/$organizationSlug': typeof OrganizationSlugIndexRoute
  '/$organizationSlug/blueprints/$': typeof OrganizationSlugBlueprintsSplatRoute
  '/$organizationSlug/statistics/$': typeof OrganizationSlugStatisticsSplatRoute
  '/$organizationSlug/characters': typeof OrganizationSlugCharactersIndexRoute
  '/$organizationSlug/events': typeof OrganizationSlugEventsIndexRoute
  '/$organizationSlug/invoice': typeof OrganizationSlugInvoiceIndexRoute
  '/$organizationSlug/reports': typeof OrganizationSlugReportsIndexRoute
  '/$organizationSlug/branches/$branchId/$': typeof OrganizationSlugBranchesBranchIdSplatRoute
  '/$organizationSlug/branches/$branchId/attendance': typeof OrganizationSlugBranchesBranchIdAttendanceRoute
  '/$organizationSlug/branches/$branchId/caps': typeof OrganizationSlugBranchesBranchIdCapsRoute
  '/$organizationSlug/branches/$branchId/contracts': typeof OrganizationSlugBranchesBranchIdContractsRoute
  '/$organizationSlug/branches/$branchId/corrective_actions': typeof OrganizationSlugBranchesBranchIdCorrective_actionsRoute
  '/$organizationSlug/branches/$branchId/locations': typeof OrganizationSlugBranchesBranchIdLocationsRoute
  '/$organizationSlug/events/$eventId/$': typeof OrganizationSlugEventsEventIdSplatRoute
  '/$organizationSlug/events/$eventId/basics': typeof OrganizationSlugEventsEventIdBasicsRoute
  '/$organizationSlug/events/$eventId/checkout': typeof OrganizationSlugEventsEventIdCheckoutRoute
  '/$organizationSlug/events/$eventId/logistics': typeof OrganizationSlugEventsEventIdLogisticsRoute
  '/$organizationSlug/events/$eventId/printLedger': typeof OrganizationSlugEventsEventIdPrintLedgerRoute
  '/$organizationSlug/events/$eventId/printouts': typeof OrganizationSlugEventsEventIdPrintoutsRoute
  '/$organizationSlug/events/$eventId/sheets': typeof OrganizationSlugEventsEventIdSheetsRoute
  '/$organizationSlug/events/$eventId/shifts': typeof OrganizationSlugEventsEventIdShiftsRoute
  '/$organizationSlug/events/$eventId/tickets': typeof OrganizationSlugEventsEventIdTicketsRoute
  '/$organizationSlug/events/$eventId/transactions_audit': typeof OrganizationSlugEventsEventIdTransactions_auditRoute
  '/$organizationSlug/events/$eventId/war_room': typeof OrganizationSlugEventsEventIdWar_roomRoute
  '/$organizationSlug/mechanics/diseases/$': typeof OrganizationSlugMechanicsDiseasesSplatRoute
  '/$organizationSlug/mechanics/faiths/$': typeof OrganizationSlugMechanicsFaithsSplatRoute
  '/$organizationSlug/mechanics/societies/$': typeof OrganizationSlugMechanicsSocietiesSplatRoute
  '/$organizationSlug/mechanics/threats/$': typeof OrganizationSlugMechanicsThreatsSplatRoute
  '/$organizationSlug/players/$playerId/$': typeof OrganizationSlugPlayersPlayerIdSplatRoute
  '/$organizationSlug/players/$playerId/attendance': typeof OrganizationSlugPlayersPlayerIdAttendanceRoute
  '/$organizationSlug/players/$playerId/corrective_actions': typeof OrganizationSlugPlayersPlayerIdCorrective_actionsRoute
  '/$organizationSlug/players/$playerId/memberships': typeof OrganizationSlugPlayersPlayerIdMembershipsRoute
  '/$organizationSlug/players/$playerId/perks': typeof OrganizationSlugPlayersPlayerIdPerksRoute
  '/$organizationSlug/players/$playerId/referrals': typeof OrganizationSlugPlayersPlayerIdReferralsRoute
  '/$organizationSlug/reports/caps/$branchId': typeof OrganizationSlugReportsCapsBranchIdRoute
  '/$organizationSlug/reports/corrective_actions/$branchId': typeof OrganizationSlugReportsCorrective_actionsBranchIdRoute
  '/$organizationSlug/blueprints/tabular': typeof OrganizationSlugBlueprintsTabularIndexRoute
  '/$organizationSlug/branches/$branchId': typeof OrganizationSlugBranchesBranchIdIndexRoute
  '/$organizationSlug/events/$eventId': typeof OrganizationSlugEventsEventIdIndexRoute
  '/$organizationSlug/mechanics/dice_roller': typeof OrganizationSlugMechanicsDice_rollerIndexRoute
  '/$organizationSlug/players/$playerId': typeof OrganizationSlugPlayersPlayerIdIndexRoute
  '/$organizationSlug/reports/caps': typeof OrganizationSlugReportsCapsIndexRoute
  '/$organizationSlug/reports/character_retirements': typeof OrganizationSlugReportsCharacter_retirementsIndexRoute
  '/$organizationSlug/reports/corrective_actions': typeof OrganizationSlugReportsCorrective_actionsIndexRoute
  '/$organizationSlug/reports/growth': typeof OrganizationSlugReportsGrowthIndexRoute
  '/$organizationSlug/reports/memberships': typeof OrganizationSlugReportsMembershipsIndexRoute
  '/$organizationSlug/reports/players': typeof OrganizationSlugReportsPlayersIndexRoute
  '/$organizationSlug/settings/special_dates': typeof OrganizationSlugSettingsSpecial_datesIndexRoute
  '/$organizationSlug/events/$eventId/blueprints/$': typeof OrganizationSlugEventsEventIdBlueprintsSplatRoute
  '/$organizationSlug/events/$eventId/mods': typeof OrganizationSlugEventsEventIdModsIndexRoute
  '/$organizationSlug/players/$playerId/characters': typeof OrganizationSlugPlayersPlayerIdCharactersIndexRoute
  '/$organizationSlug/events/$eventId/mods/$modId/battlefield': typeof OrganizationSlugEventsEventIdModsModIdBattlefieldRoute
  '/$organizationSlug/events/$eventId/mods/$modId/rewards': typeof OrganizationSlugEventsEventIdModsModIdRewardsRoute
  '/$organizationSlug/events/$eventId/mods/$modId/storyteller': typeof OrganizationSlugEventsEventIdModsModIdStorytellerRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/$': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/inventory': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/journal': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/printout': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute
  '/$organizationSlug/events/$eventId/mods/$modId': typeof OrganizationSlugEventsEventIdModsModIdIndexRoute
  '/$organizationSlug/players/$playerId/characters/$characterId': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/$organizationSlug/': typeof OrganizationSlugIndexRoute
  '/$organizationSlug/branches/$branchId': typeof OrganizationSlugBranchesBranchIdRouteRouteWithChildren
  '/$organizationSlug/events/$eventId': typeof OrganizationSlugEventsEventIdRouteRouteWithChildren
  '/$organizationSlug/players/$playerId': typeof OrganizationSlugPlayersPlayerIdRouteRouteWithChildren
  '/$organizationSlug/blueprints/$': typeof OrganizationSlugBlueprintsSplatRoute
  '/$organizationSlug/statistics/$': typeof OrganizationSlugStatisticsSplatRoute
  '/$organizationSlug/characters/': typeof OrganizationSlugCharactersIndexRoute
  '/$organizationSlug/events/': typeof OrganizationSlugEventsIndexRoute
  '/$organizationSlug/invoice/': typeof OrganizationSlugInvoiceIndexRoute
  '/$organizationSlug/reports/': typeof OrganizationSlugReportsIndexRoute
  '/$organizationSlug/branches/$branchId/$': typeof OrganizationSlugBranchesBranchIdSplatRoute
  '/$organizationSlug/branches/$branchId/attendance': typeof OrganizationSlugBranchesBranchIdAttendanceRoute
  '/$organizationSlug/branches/$branchId/caps': typeof OrganizationSlugBranchesBranchIdCapsRoute
  '/$organizationSlug/branches/$branchId/contracts': typeof OrganizationSlugBranchesBranchIdContractsRoute
  '/$organizationSlug/branches/$branchId/corrective_actions': typeof OrganizationSlugBranchesBranchIdCorrective_actionsRoute
  '/$organizationSlug/branches/$branchId/locations': typeof OrganizationSlugBranchesBranchIdLocationsRoute
  '/$organizationSlug/events/$eventId/$': typeof OrganizationSlugEventsEventIdSplatRoute
  '/$organizationSlug/events/$eventId/basics': typeof OrganizationSlugEventsEventIdBasicsRoute
  '/$organizationSlug/events/$eventId/checkout': typeof OrganizationSlugEventsEventIdCheckoutRoute
  '/$organizationSlug/events/$eventId/logistics': typeof OrganizationSlugEventsEventIdLogisticsRoute
  '/$organizationSlug/events/$eventId/printLedger': typeof OrganizationSlugEventsEventIdPrintLedgerRoute
  '/$organizationSlug/events/$eventId/printouts': typeof OrganizationSlugEventsEventIdPrintoutsRoute
  '/$organizationSlug/events/$eventId/sheets': typeof OrganizationSlugEventsEventIdSheetsRoute
  '/$organizationSlug/events/$eventId/shifts': typeof OrganizationSlugEventsEventIdShiftsRoute
  '/$organizationSlug/events/$eventId/tickets': typeof OrganizationSlugEventsEventIdTicketsRoute
  '/$organizationSlug/events/$eventId/transactions_audit': typeof OrganizationSlugEventsEventIdTransactions_auditRoute
  '/$organizationSlug/events/$eventId/war_room': typeof OrganizationSlugEventsEventIdWar_roomRoute
  '/$organizationSlug/mechanics/diseases/$': typeof OrganizationSlugMechanicsDiseasesSplatRoute
  '/$organizationSlug/mechanics/faiths/$': typeof OrganizationSlugMechanicsFaithsSplatRoute
  '/$organizationSlug/mechanics/societies/$': typeof OrganizationSlugMechanicsSocietiesSplatRoute
  '/$organizationSlug/mechanics/threats/$': typeof OrganizationSlugMechanicsThreatsSplatRoute
  '/$organizationSlug/players/$playerId/$': typeof OrganizationSlugPlayersPlayerIdSplatRoute
  '/$organizationSlug/players/$playerId/attendance': typeof OrganizationSlugPlayersPlayerIdAttendanceRoute
  '/$organizationSlug/players/$playerId/corrective_actions': typeof OrganizationSlugPlayersPlayerIdCorrective_actionsRoute
  '/$organizationSlug/players/$playerId/memberships': typeof OrganizationSlugPlayersPlayerIdMembershipsRoute
  '/$organizationSlug/players/$playerId/perks': typeof OrganizationSlugPlayersPlayerIdPerksRoute
  '/$organizationSlug/players/$playerId/referrals': typeof OrganizationSlugPlayersPlayerIdReferralsRoute
  '/$organizationSlug/reports/caps/$branchId': typeof OrganizationSlugReportsCapsBranchIdRoute
  '/$organizationSlug/reports/corrective_actions/$branchId': typeof OrganizationSlugReportsCorrective_actionsBranchIdRoute
  '/$organizationSlug/blueprints/tabular/': typeof OrganizationSlugBlueprintsTabularIndexRoute
  '/$organizationSlug/branches/$branchId/': typeof OrganizationSlugBranchesBranchIdIndexRoute
  '/$organizationSlug/events/$eventId/': typeof OrganizationSlugEventsEventIdIndexRoute
  '/$organizationSlug/mechanics/dice_roller/': typeof OrganizationSlugMechanicsDice_rollerIndexRoute
  '/$organizationSlug/players/$playerId/': typeof OrganizationSlugPlayersPlayerIdIndexRoute
  '/$organizationSlug/reports/caps/': typeof OrganizationSlugReportsCapsIndexRoute
  '/$organizationSlug/reports/character_retirements/': typeof OrganizationSlugReportsCharacter_retirementsIndexRoute
  '/$organizationSlug/reports/corrective_actions/': typeof OrganizationSlugReportsCorrective_actionsIndexRoute
  '/$organizationSlug/reports/growth/': typeof OrganizationSlugReportsGrowthIndexRoute
  '/$organizationSlug/reports/memberships/': typeof OrganizationSlugReportsMembershipsIndexRoute
  '/$organizationSlug/reports/players/': typeof OrganizationSlugReportsPlayersIndexRoute
  '/$organizationSlug/settings/special_dates/': typeof OrganizationSlugSettingsSpecial_datesIndexRoute
  '/$organizationSlug/events/$eventId/mods/$modId': typeof OrganizationSlugEventsEventIdModsModIdRouteRouteWithChildren
  '/$organizationSlug/players/$playerId/characters/$characterId': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteWithChildren
  '/$organizationSlug/events/$eventId/blueprints/$': typeof OrganizationSlugEventsEventIdBlueprintsSplatRoute
  '/$organizationSlug/events/$eventId/mods/': typeof OrganizationSlugEventsEventIdModsIndexRoute
  '/$organizationSlug/players/$playerId/characters/': typeof OrganizationSlugPlayersPlayerIdCharactersIndexRoute
  '/$organizationSlug/events/$eventId/mods/$modId/battlefield': typeof OrganizationSlugEventsEventIdModsModIdBattlefieldRoute
  '/$organizationSlug/events/$eventId/mods/$modId/rewards': typeof OrganizationSlugEventsEventIdModsModIdRewardsRoute
  '/$organizationSlug/events/$eventId/mods/$modId/storyteller': typeof OrganizationSlugEventsEventIdModsModIdStorytellerRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/$': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/inventory': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/journal': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/printout': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute
  '/$organizationSlug/events/$eventId/mods/$modId/': typeof OrganizationSlugEventsEventIdModsModIdIndexRoute
  '/$organizationSlug/players/$playerId/characters/$characterId/': typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/$organizationSlug/'
    | '/$organizationSlug/branches/$branchId'
    | '/$organizationSlug/events/$eventId'
    | '/$organizationSlug/players/$playerId'
    | '/$organizationSlug/blueprints/$'
    | '/$organizationSlug/statistics/$'
    | '/$organizationSlug/characters/'
    | '/$organizationSlug/events/'
    | '/$organizationSlug/invoice/'
    | '/$organizationSlug/reports/'
    | '/$organizationSlug/branches/$branchId/$'
    | '/$organizationSlug/branches/$branchId/attendance'
    | '/$organizationSlug/branches/$branchId/caps'
    | '/$organizationSlug/branches/$branchId/contracts'
    | '/$organizationSlug/branches/$branchId/corrective_actions'
    | '/$organizationSlug/branches/$branchId/locations'
    | '/$organizationSlug/events/$eventId/$'
    | '/$organizationSlug/events/$eventId/basics'
    | '/$organizationSlug/events/$eventId/checkout'
    | '/$organizationSlug/events/$eventId/logistics'
    | '/$organizationSlug/events/$eventId/printLedger'
    | '/$organizationSlug/events/$eventId/printouts'
    | '/$organizationSlug/events/$eventId/sheets'
    | '/$organizationSlug/events/$eventId/shifts'
    | '/$organizationSlug/events/$eventId/tickets'
    | '/$organizationSlug/events/$eventId/transactions_audit'
    | '/$organizationSlug/events/$eventId/war_room'
    | '/$organizationSlug/mechanics/diseases/$'
    | '/$organizationSlug/mechanics/faiths/$'
    | '/$organizationSlug/mechanics/societies/$'
    | '/$organizationSlug/mechanics/threats/$'
    | '/$organizationSlug/players/$playerId/$'
    | '/$organizationSlug/players/$playerId/attendance'
    | '/$organizationSlug/players/$playerId/corrective_actions'
    | '/$organizationSlug/players/$playerId/memberships'
    | '/$organizationSlug/players/$playerId/perks'
    | '/$organizationSlug/players/$playerId/referrals'
    | '/$organizationSlug/reports/caps/$branchId'
    | '/$organizationSlug/reports/corrective_actions/$branchId'
    | '/$organizationSlug/blueprints/tabular/'
    | '/$organizationSlug/branches/$branchId/'
    | '/$organizationSlug/events/$eventId/'
    | '/$organizationSlug/mechanics/dice_roller/'
    | '/$organizationSlug/players/$playerId/'
    | '/$organizationSlug/reports/caps/'
    | '/$organizationSlug/reports/character_retirements/'
    | '/$organizationSlug/reports/corrective_actions/'
    | '/$organizationSlug/reports/growth/'
    | '/$organizationSlug/reports/memberships/'
    | '/$organizationSlug/reports/players/'
    | '/$organizationSlug/settings/special_dates/'
    | '/$organizationSlug/events/$eventId/mods/$modId'
    | '/$organizationSlug/players/$playerId/characters/$characterId'
    | '/$organizationSlug/events/$eventId/blueprints/$'
    | '/$organizationSlug/events/$eventId/mods/'
    | '/$organizationSlug/players/$playerId/characters/'
    | '/$organizationSlug/events/$eventId/mods/$modId/battlefield'
    | '/$organizationSlug/events/$eventId/mods/$modId/rewards'
    | '/$organizationSlug/events/$eventId/mods/$modId/storyteller'
    | '/$organizationSlug/players/$playerId/characters/$characterId/$'
    | '/$organizationSlug/players/$playerId/characters/$characterId/inventory'
    | '/$organizationSlug/players/$playerId/characters/$characterId/journal'
    | '/$organizationSlug/players/$playerId/characters/$characterId/printout'
    | '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'
    | '/$organizationSlug/events/$eventId/mods/$modId/'
    | '/$organizationSlug/players/$playerId/characters/$characterId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/$organizationSlug'
    | '/$organizationSlug/blueprints/$'
    | '/$organizationSlug/statistics/$'
    | '/$organizationSlug/characters'
    | '/$organizationSlug/events'
    | '/$organizationSlug/invoice'
    | '/$organizationSlug/reports'
    | '/$organizationSlug/branches/$branchId/$'
    | '/$organizationSlug/branches/$branchId/attendance'
    | '/$organizationSlug/branches/$branchId/caps'
    | '/$organizationSlug/branches/$branchId/contracts'
    | '/$organizationSlug/branches/$branchId/corrective_actions'
    | '/$organizationSlug/branches/$branchId/locations'
    | '/$organizationSlug/events/$eventId/$'
    | '/$organizationSlug/events/$eventId/basics'
    | '/$organizationSlug/events/$eventId/checkout'
    | '/$organizationSlug/events/$eventId/logistics'
    | '/$organizationSlug/events/$eventId/printLedger'
    | '/$organizationSlug/events/$eventId/printouts'
    | '/$organizationSlug/events/$eventId/sheets'
    | '/$organizationSlug/events/$eventId/shifts'
    | '/$organizationSlug/events/$eventId/tickets'
    | '/$organizationSlug/events/$eventId/transactions_audit'
    | '/$organizationSlug/events/$eventId/war_room'
    | '/$organizationSlug/mechanics/diseases/$'
    | '/$organizationSlug/mechanics/faiths/$'
    | '/$organizationSlug/mechanics/societies/$'
    | '/$organizationSlug/mechanics/threats/$'
    | '/$organizationSlug/players/$playerId/$'
    | '/$organizationSlug/players/$playerId/attendance'
    | '/$organizationSlug/players/$playerId/corrective_actions'
    | '/$organizationSlug/players/$playerId/memberships'
    | '/$organizationSlug/players/$playerId/perks'
    | '/$organizationSlug/players/$playerId/referrals'
    | '/$organizationSlug/reports/caps/$branchId'
    | '/$organizationSlug/reports/corrective_actions/$branchId'
    | '/$organizationSlug/blueprints/tabular'
    | '/$organizationSlug/branches/$branchId'
    | '/$organizationSlug/events/$eventId'
    | '/$organizationSlug/mechanics/dice_roller'
    | '/$organizationSlug/players/$playerId'
    | '/$organizationSlug/reports/caps'
    | '/$organizationSlug/reports/character_retirements'
    | '/$organizationSlug/reports/corrective_actions'
    | '/$organizationSlug/reports/growth'
    | '/$organizationSlug/reports/memberships'
    | '/$organizationSlug/reports/players'
    | '/$organizationSlug/settings/special_dates'
    | '/$organizationSlug/events/$eventId/blueprints/$'
    | '/$organizationSlug/events/$eventId/mods'
    | '/$organizationSlug/players/$playerId/characters'
    | '/$organizationSlug/events/$eventId/mods/$modId/battlefield'
    | '/$organizationSlug/events/$eventId/mods/$modId/rewards'
    | '/$organizationSlug/events/$eventId/mods/$modId/storyteller'
    | '/$organizationSlug/players/$playerId/characters/$characterId/$'
    | '/$organizationSlug/players/$playerId/characters/$characterId/inventory'
    | '/$organizationSlug/players/$playerId/characters/$characterId/journal'
    | '/$organizationSlug/players/$playerId/characters/$characterId/printout'
    | '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'
    | '/$organizationSlug/events/$eventId/mods/$modId'
    | '/$organizationSlug/players/$playerId/characters/$characterId'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/$organizationSlug/'
    | '/$organizationSlug/branches/$branchId'
    | '/$organizationSlug/events/$eventId'
    | '/$organizationSlug/players/$playerId'
    | '/$organizationSlug/blueprints/$'
    | '/$organizationSlug/statistics/$'
    | '/$organizationSlug/characters/'
    | '/$organizationSlug/events/'
    | '/$organizationSlug/invoice/'
    | '/$organizationSlug/reports/'
    | '/$organizationSlug/branches/$branchId/$'
    | '/$organizationSlug/branches/$branchId/attendance'
    | '/$organizationSlug/branches/$branchId/caps'
    | '/$organizationSlug/branches/$branchId/contracts'
    | '/$organizationSlug/branches/$branchId/corrective_actions'
    | '/$organizationSlug/branches/$branchId/locations'
    | '/$organizationSlug/events/$eventId/$'
    | '/$organizationSlug/events/$eventId/basics'
    | '/$organizationSlug/events/$eventId/checkout'
    | '/$organizationSlug/events/$eventId/logistics'
    | '/$organizationSlug/events/$eventId/printLedger'
    | '/$organizationSlug/events/$eventId/printouts'
    | '/$organizationSlug/events/$eventId/sheets'
    | '/$organizationSlug/events/$eventId/shifts'
    | '/$organizationSlug/events/$eventId/tickets'
    | '/$organizationSlug/events/$eventId/transactions_audit'
    | '/$organizationSlug/events/$eventId/war_room'
    | '/$organizationSlug/mechanics/diseases/$'
    | '/$organizationSlug/mechanics/faiths/$'
    | '/$organizationSlug/mechanics/societies/$'
    | '/$organizationSlug/mechanics/threats/$'
    | '/$organizationSlug/players/$playerId/$'
    | '/$organizationSlug/players/$playerId/attendance'
    | '/$organizationSlug/players/$playerId/corrective_actions'
    | '/$organizationSlug/players/$playerId/memberships'
    | '/$organizationSlug/players/$playerId/perks'
    | '/$organizationSlug/players/$playerId/referrals'
    | '/$organizationSlug/reports/caps/$branchId'
    | '/$organizationSlug/reports/corrective_actions/$branchId'
    | '/$organizationSlug/blueprints/tabular/'
    | '/$organizationSlug/branches/$branchId/'
    | '/$organizationSlug/events/$eventId/'
    | '/$organizationSlug/mechanics/dice_roller/'
    | '/$organizationSlug/players/$playerId/'
    | '/$organizationSlug/reports/caps/'
    | '/$organizationSlug/reports/character_retirements/'
    | '/$organizationSlug/reports/corrective_actions/'
    | '/$organizationSlug/reports/growth/'
    | '/$organizationSlug/reports/memberships/'
    | '/$organizationSlug/reports/players/'
    | '/$organizationSlug/settings/special_dates/'
    | '/$organizationSlug/events/$eventId/mods/$modId'
    | '/$organizationSlug/players/$playerId/characters/$characterId'
    | '/$organizationSlug/events/$eventId/blueprints/$'
    | '/$organizationSlug/events/$eventId/mods/'
    | '/$organizationSlug/players/$playerId/characters/'
    | '/$organizationSlug/events/$eventId/mods/$modId/battlefield'
    | '/$organizationSlug/events/$eventId/mods/$modId/rewards'
    | '/$organizationSlug/events/$eventId/mods/$modId/storyteller'
    | '/$organizationSlug/players/$playerId/characters/$characterId/$'
    | '/$organizationSlug/players/$playerId/characters/$characterId/inventory'
    | '/$organizationSlug/players/$playerId/characters/$characterId/journal'
    | '/$organizationSlug/players/$playerId/characters/$characterId/printout'
    | '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'
    | '/$organizationSlug/events/$eventId/mods/$modId/'
    | '/$organizationSlug/players/$playerId/characters/$characterId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRoute: typeof CalendarRoute
  OrganizationSlugIndexRoute: typeof OrganizationSlugIndexRoute
  OrganizationSlugBranchesBranchIdRouteRoute: typeof OrganizationSlugBranchesBranchIdRouteRouteWithChildren
  OrganizationSlugEventsEventIdRouteRoute: typeof OrganizationSlugEventsEventIdRouteRouteWithChildren
  OrganizationSlugPlayersPlayerIdRouteRoute: typeof OrganizationSlugPlayersPlayerIdRouteRouteWithChildren
  OrganizationSlugBlueprintsSplatRoute: typeof OrganizationSlugBlueprintsSplatRoute
  OrganizationSlugStatisticsSplatRoute: typeof OrganizationSlugStatisticsSplatRoute
  OrganizationSlugCharactersIndexRoute: typeof OrganizationSlugCharactersIndexRoute
  OrganizationSlugEventsIndexRoute: typeof OrganizationSlugEventsIndexRoute
  OrganizationSlugInvoiceIndexRoute: typeof OrganizationSlugInvoiceIndexRoute
  OrganizationSlugReportsIndexRoute: typeof OrganizationSlugReportsIndexRoute
  OrganizationSlugMechanicsDiseasesSplatRoute: typeof OrganizationSlugMechanicsDiseasesSplatRoute
  OrganizationSlugMechanicsFaithsSplatRoute: typeof OrganizationSlugMechanicsFaithsSplatRoute
  OrganizationSlugMechanicsSocietiesSplatRoute: typeof OrganizationSlugMechanicsSocietiesSplatRoute
  OrganizationSlugMechanicsThreatsSplatRoute: typeof OrganizationSlugMechanicsThreatsSplatRoute
  OrganizationSlugReportsCapsBranchIdRoute: typeof OrganizationSlugReportsCapsBranchIdRoute
  OrganizationSlugReportsCorrective_actionsBranchIdRoute: typeof OrganizationSlugReportsCorrective_actionsBranchIdRoute
  OrganizationSlugBlueprintsTabularIndexRoute: typeof OrganizationSlugBlueprintsTabularIndexRoute
  OrganizationSlugMechanicsDice_rollerIndexRoute: typeof OrganizationSlugMechanicsDice_rollerIndexRoute
  OrganizationSlugReportsCapsIndexRoute: typeof OrganizationSlugReportsCapsIndexRoute
  OrganizationSlugReportsCharacter_retirementsIndexRoute: typeof OrganizationSlugReportsCharacter_retirementsIndexRoute
  OrganizationSlugReportsCorrective_actionsIndexRoute: typeof OrganizationSlugReportsCorrective_actionsIndexRoute
  OrganizationSlugReportsGrowthIndexRoute: typeof OrganizationSlugReportsGrowthIndexRoute
  OrganizationSlugReportsMembershipsIndexRoute: typeof OrganizationSlugReportsMembershipsIndexRoute
  OrganizationSlugReportsPlayersIndexRoute: typeof OrganizationSlugReportsPlayersIndexRoute
  OrganizationSlugSettingsSpecial_datesIndexRoute: typeof OrganizationSlugSettingsSpecial_datesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/': {
      id: '/$organizationSlug/'
      path: '/$organizationSlug'
      fullPath: '/$organizationSlug/'
      preLoaderRoute: typeof OrganizationSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/blueprints/$': {
      id: '/$organizationSlug/blueprints/$'
      path: '/$organizationSlug/blueprints/$'
      fullPath: '/$organizationSlug/blueprints/$'
      preLoaderRoute: typeof OrganizationSlugBlueprintsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/branches/$branchId': {
      id: '/$organizationSlug/branches/$branchId'
      path: '/$organizationSlug/branches/$branchId'
      fullPath: '/$organizationSlug/branches/$branchId'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/characters/': {
      id: '/$organizationSlug/characters/'
      path: '/$organizationSlug/characters'
      fullPath: '/$organizationSlug/characters/'
      preLoaderRoute: typeof OrganizationSlugCharactersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/events/': {
      id: '/$organizationSlug/events/'
      path: '/$organizationSlug/events'
      fullPath: '/$organizationSlug/events/'
      preLoaderRoute: typeof OrganizationSlugEventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/events/$eventId': {
      id: '/$organizationSlug/events/$eventId'
      path: '/$organizationSlug/events/$eventId'
      fullPath: '/$organizationSlug/events/$eventId'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/invoice/': {
      id: '/$organizationSlug/invoice/'
      path: '/$organizationSlug/invoice'
      fullPath: '/$organizationSlug/invoice/'
      preLoaderRoute: typeof OrganizationSlugInvoiceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/players/$playerId': {
      id: '/$organizationSlug/players/$playerId'
      path: '/$organizationSlug/players/$playerId'
      fullPath: '/$organizationSlug/players/$playerId'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/': {
      id: '/$organizationSlug/reports/'
      path: '/$organizationSlug/reports'
      fullPath: '/$organizationSlug/reports/'
      preLoaderRoute: typeof OrganizationSlugReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/statistics/$': {
      id: '/$organizationSlug/statistics/$'
      path: '/$organizationSlug/statistics/$'
      fullPath: '/$organizationSlug/statistics/$'
      preLoaderRoute: typeof OrganizationSlugStatisticsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/blueprints/tabular/': {
      id: '/$organizationSlug/blueprints/tabular/'
      path: '/$organizationSlug/blueprints/tabular'
      fullPath: '/$organizationSlug/blueprints/tabular/'
      preLoaderRoute: typeof OrganizationSlugBlueprintsTabularIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/branches/$branchId/': {
      id: '/$organizationSlug/branches/$branchId/'
      path: '/'
      fullPath: '/$organizationSlug/branches/$branchId/'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdIndexRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/$': {
      id: '/$organizationSlug/branches/$branchId/$'
      path: '/$'
      fullPath: '/$organizationSlug/branches/$branchId/$'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdSplatRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/attendance': {
      id: '/$organizationSlug/branches/$branchId/attendance'
      path: '/attendance'
      fullPath: '/$organizationSlug/branches/$branchId/attendance'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdAttendanceRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/caps': {
      id: '/$organizationSlug/branches/$branchId/caps'
      path: '/caps'
      fullPath: '/$organizationSlug/branches/$branchId/caps'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdCapsRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/contracts': {
      id: '/$organizationSlug/branches/$branchId/contracts'
      path: '/contracts'
      fullPath: '/$organizationSlug/branches/$branchId/contracts'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdContractsRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/corrective_actions': {
      id: '/$organizationSlug/branches/$branchId/corrective_actions'
      path: '/corrective_actions'
      fullPath: '/$organizationSlug/branches/$branchId/corrective_actions'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdCorrective_actionsRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/branches/$branchId/locations': {
      id: '/$organizationSlug/branches/$branchId/locations'
      path: '/locations'
      fullPath: '/$organizationSlug/branches/$branchId/locations'
      preLoaderRoute: typeof OrganizationSlugBranchesBranchIdLocationsRouteImport
      parentRoute: typeof OrganizationSlugBranchesBranchIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/': {
      id: '/$organizationSlug/events/$eventId/'
      path: '/'
      fullPath: '/$organizationSlug/events/$eventId/'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdIndexRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/$': {
      id: '/$organizationSlug/events/$eventId/$'
      path: '/$'
      fullPath: '/$organizationSlug/events/$eventId/$'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdSplatRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/basics': {
      id: '/$organizationSlug/events/$eventId/basics'
      path: '/basics'
      fullPath: '/$organizationSlug/events/$eventId/basics'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdBasicsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/checkout': {
      id: '/$organizationSlug/events/$eventId/checkout'
      path: '/checkout'
      fullPath: '/$organizationSlug/events/$eventId/checkout'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdCheckoutRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/logistics': {
      id: '/$organizationSlug/events/$eventId/logistics'
      path: '/logistics'
      fullPath: '/$organizationSlug/events/$eventId/logistics'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdLogisticsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/printLedger': {
      id: '/$organizationSlug/events/$eventId/printLedger'
      path: '/printLedger'
      fullPath: '/$organizationSlug/events/$eventId/printLedger'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdPrintLedgerRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/printouts': {
      id: '/$organizationSlug/events/$eventId/printouts'
      path: '/printouts'
      fullPath: '/$organizationSlug/events/$eventId/printouts'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdPrintoutsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/sheets': {
      id: '/$organizationSlug/events/$eventId/sheets'
      path: '/sheets'
      fullPath: '/$organizationSlug/events/$eventId/sheets'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdSheetsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/shifts': {
      id: '/$organizationSlug/events/$eventId/shifts'
      path: '/shifts'
      fullPath: '/$organizationSlug/events/$eventId/shifts'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdShiftsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/tickets': {
      id: '/$organizationSlug/events/$eventId/tickets'
      path: '/tickets'
      fullPath: '/$organizationSlug/events/$eventId/tickets'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdTicketsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/transactions_audit': {
      id: '/$organizationSlug/events/$eventId/transactions_audit'
      path: '/transactions_audit'
      fullPath: '/$organizationSlug/events/$eventId/transactions_audit'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdTransactions_auditRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/war_room': {
      id: '/$organizationSlug/events/$eventId/war_room'
      path: '/war_room'
      fullPath: '/$organizationSlug/events/$eventId/war_room'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdWar_roomRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/mechanics/dice_roller/': {
      id: '/$organizationSlug/mechanics/dice_roller/'
      path: '/$organizationSlug/mechanics/dice_roller'
      fullPath: '/$organizationSlug/mechanics/dice_roller/'
      preLoaderRoute: typeof OrganizationSlugMechanicsDice_rollerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/mechanics/diseases/$': {
      id: '/$organizationSlug/mechanics/diseases/$'
      path: '/$organizationSlug/mechanics/diseases/$'
      fullPath: '/$organizationSlug/mechanics/diseases/$'
      preLoaderRoute: typeof OrganizationSlugMechanicsDiseasesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/mechanics/faiths/$': {
      id: '/$organizationSlug/mechanics/faiths/$'
      path: '/$organizationSlug/mechanics/faiths/$'
      fullPath: '/$organizationSlug/mechanics/faiths/$'
      preLoaderRoute: typeof OrganizationSlugMechanicsFaithsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/mechanics/societies/$': {
      id: '/$organizationSlug/mechanics/societies/$'
      path: '/$organizationSlug/mechanics/societies/$'
      fullPath: '/$organizationSlug/mechanics/societies/$'
      preLoaderRoute: typeof OrganizationSlugMechanicsSocietiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/mechanics/threats/$': {
      id: '/$organizationSlug/mechanics/threats/$'
      path: '/$organizationSlug/mechanics/threats/$'
      fullPath: '/$organizationSlug/mechanics/threats/$'
      preLoaderRoute: typeof OrganizationSlugMechanicsThreatsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/players/$playerId/': {
      id: '/$organizationSlug/players/$playerId/'
      path: '/'
      fullPath: '/$organizationSlug/players/$playerId/'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdIndexRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/$': {
      id: '/$organizationSlug/players/$playerId/$'
      path: '/$'
      fullPath: '/$organizationSlug/players/$playerId/$'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdSplatRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/attendance': {
      id: '/$organizationSlug/players/$playerId/attendance'
      path: '/attendance'
      fullPath: '/$organizationSlug/players/$playerId/attendance'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdAttendanceRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/corrective_actions': {
      id: '/$organizationSlug/players/$playerId/corrective_actions'
      path: '/corrective_actions'
      fullPath: '/$organizationSlug/players/$playerId/corrective_actions'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCorrective_actionsRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/memberships': {
      id: '/$organizationSlug/players/$playerId/memberships'
      path: '/memberships'
      fullPath: '/$organizationSlug/players/$playerId/memberships'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdMembershipsRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/perks': {
      id: '/$organizationSlug/players/$playerId/perks'
      path: '/perks'
      fullPath: '/$organizationSlug/players/$playerId/perks'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdPerksRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/referrals': {
      id: '/$organizationSlug/players/$playerId/referrals'
      path: '/referrals'
      fullPath: '/$organizationSlug/players/$playerId/referrals'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdReferralsRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/reports/caps/': {
      id: '/$organizationSlug/reports/caps/'
      path: '/$organizationSlug/reports/caps'
      fullPath: '/$organizationSlug/reports/caps/'
      preLoaderRoute: typeof OrganizationSlugReportsCapsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/caps/$branchId': {
      id: '/$organizationSlug/reports/caps/$branchId'
      path: '/$organizationSlug/reports/caps/$branchId'
      fullPath: '/$organizationSlug/reports/caps/$branchId'
      preLoaderRoute: typeof OrganizationSlugReportsCapsBranchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/character_retirements/': {
      id: '/$organizationSlug/reports/character_retirements/'
      path: '/$organizationSlug/reports/character_retirements'
      fullPath: '/$organizationSlug/reports/character_retirements/'
      preLoaderRoute: typeof OrganizationSlugReportsCharacter_retirementsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/corrective_actions/': {
      id: '/$organizationSlug/reports/corrective_actions/'
      path: '/$organizationSlug/reports/corrective_actions'
      fullPath: '/$organizationSlug/reports/corrective_actions/'
      preLoaderRoute: typeof OrganizationSlugReportsCorrective_actionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/corrective_actions/$branchId': {
      id: '/$organizationSlug/reports/corrective_actions/$branchId'
      path: '/$organizationSlug/reports/corrective_actions/$branchId'
      fullPath: '/$organizationSlug/reports/corrective_actions/$branchId'
      preLoaderRoute: typeof OrganizationSlugReportsCorrective_actionsBranchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/growth/': {
      id: '/$organizationSlug/reports/growth/'
      path: '/$organizationSlug/reports/growth'
      fullPath: '/$organizationSlug/reports/growth/'
      preLoaderRoute: typeof OrganizationSlugReportsGrowthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/memberships/': {
      id: '/$organizationSlug/reports/memberships/'
      path: '/$organizationSlug/reports/memberships'
      fullPath: '/$organizationSlug/reports/memberships/'
      preLoaderRoute: typeof OrganizationSlugReportsMembershipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/reports/players/': {
      id: '/$organizationSlug/reports/players/'
      path: '/$organizationSlug/reports/players'
      fullPath: '/$organizationSlug/reports/players/'
      preLoaderRoute: typeof OrganizationSlugReportsPlayersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/settings/special_dates/': {
      id: '/$organizationSlug/settings/special_dates/'
      path: '/$organizationSlug/settings/special_dates'
      fullPath: '/$organizationSlug/settings/special_dates/'
      preLoaderRoute: typeof OrganizationSlugSettingsSpecial_datesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationSlug/events/$eventId/blueprints/$': {
      id: '/$organizationSlug/events/$eventId/blueprints/$'
      path: '/blueprints/$'
      fullPath: '/$organizationSlug/events/$eventId/blueprints/$'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdBlueprintsSplatRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/': {
      id: '/$organizationSlug/events/$eventId/mods/'
      path: '/mods'
      fullPath: '/$organizationSlug/events/$eventId/mods/'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsIndexRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/$modId': {
      id: '/$organizationSlug/events/$eventId/mods/$modId'
      path: '/mods/$modId'
      fullPath: '/$organizationSlug/events/$eventId/mods/$modId'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/': {
      id: '/$organizationSlug/players/$playerId/characters/'
      path: '/characters'
      fullPath: '/$organizationSlug/players/$playerId/characters/'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersIndexRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId'
      path: '/characters/$characterId'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/$modId/': {
      id: '/$organizationSlug/events/$eventId/mods/$modId/'
      path: '/'
      fullPath: '/$organizationSlug/events/$eventId/mods/$modId/'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsModIdIndexRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/$modId/battlefield': {
      id: '/$organizationSlug/events/$eventId/mods/$modId/battlefield'
      path: '/battlefield'
      fullPath: '/$organizationSlug/events/$eventId/mods/$modId/battlefield'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsModIdBattlefieldRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/$modId/rewards': {
      id: '/$organizationSlug/events/$eventId/mods/$modId/rewards'
      path: '/rewards'
      fullPath: '/$organizationSlug/events/$eventId/mods/$modId/rewards'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsModIdRewardsRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRoute
    }
    '/$organizationSlug/events/$eventId/mods/$modId/storyteller': {
      id: '/$organizationSlug/events/$eventId/mods/$modId/storyteller'
      path: '/storyteller'
      fullPath: '/$organizationSlug/events/$eventId/mods/$modId/storyteller'
      preLoaderRoute: typeof OrganizationSlugEventsEventIdModsModIdStorytellerRouteImport
      parentRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/'
      path: '/'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/$': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/$'
      path: '/$'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/$'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/inventory': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/inventory'
      path: '/inventory'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/inventory'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/journal': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/journal'
      path: '/journal'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/journal'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/printout': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/printout'
      path: '/printout'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/printout'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
    '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit': {
      id: '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'
      path: '/xp_audit'
      fullPath: '/$organizationSlug/players/$playerId/characters/$characterId/xp_audit'
      preLoaderRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRouteImport
      parentRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute
    }
  }
}

interface OrganizationSlugBranchesBranchIdRouteRouteChildren {
  OrganizationSlugBranchesBranchIdSplatRoute: typeof OrganizationSlugBranchesBranchIdSplatRoute
  OrganizationSlugBranchesBranchIdAttendanceRoute: typeof OrganizationSlugBranchesBranchIdAttendanceRoute
  OrganizationSlugBranchesBranchIdCapsRoute: typeof OrganizationSlugBranchesBranchIdCapsRoute
  OrganizationSlugBranchesBranchIdContractsRoute: typeof OrganizationSlugBranchesBranchIdContractsRoute
  OrganizationSlugBranchesBranchIdCorrective_actionsRoute: typeof OrganizationSlugBranchesBranchIdCorrective_actionsRoute
  OrganizationSlugBranchesBranchIdLocationsRoute: typeof OrganizationSlugBranchesBranchIdLocationsRoute
  OrganizationSlugBranchesBranchIdIndexRoute: typeof OrganizationSlugBranchesBranchIdIndexRoute
}

const OrganizationSlugBranchesBranchIdRouteRouteChildren: OrganizationSlugBranchesBranchIdRouteRouteChildren =
  {
    OrganizationSlugBranchesBranchIdSplatRoute:
      OrganizationSlugBranchesBranchIdSplatRoute,
    OrganizationSlugBranchesBranchIdAttendanceRoute:
      OrganizationSlugBranchesBranchIdAttendanceRoute,
    OrganizationSlugBranchesBranchIdCapsRoute:
      OrganizationSlugBranchesBranchIdCapsRoute,
    OrganizationSlugBranchesBranchIdContractsRoute:
      OrganizationSlugBranchesBranchIdContractsRoute,
    OrganizationSlugBranchesBranchIdCorrective_actionsRoute:
      OrganizationSlugBranchesBranchIdCorrective_actionsRoute,
    OrganizationSlugBranchesBranchIdLocationsRoute:
      OrganizationSlugBranchesBranchIdLocationsRoute,
    OrganizationSlugBranchesBranchIdIndexRoute:
      OrganizationSlugBranchesBranchIdIndexRoute,
  }

const OrganizationSlugBranchesBranchIdRouteRouteWithChildren =
  OrganizationSlugBranchesBranchIdRouteRoute._addFileChildren(
    OrganizationSlugBranchesBranchIdRouteRouteChildren,
  )

interface OrganizationSlugEventsEventIdModsModIdRouteRouteChildren {
  OrganizationSlugEventsEventIdModsModIdBattlefieldRoute: typeof OrganizationSlugEventsEventIdModsModIdBattlefieldRoute
  OrganizationSlugEventsEventIdModsModIdRewardsRoute: typeof OrganizationSlugEventsEventIdModsModIdRewardsRoute
  OrganizationSlugEventsEventIdModsModIdStorytellerRoute: typeof OrganizationSlugEventsEventIdModsModIdStorytellerRoute
  OrganizationSlugEventsEventIdModsModIdIndexRoute: typeof OrganizationSlugEventsEventIdModsModIdIndexRoute
}

const OrganizationSlugEventsEventIdModsModIdRouteRouteChildren: OrganizationSlugEventsEventIdModsModIdRouteRouteChildren =
  {
    OrganizationSlugEventsEventIdModsModIdBattlefieldRoute:
      OrganizationSlugEventsEventIdModsModIdBattlefieldRoute,
    OrganizationSlugEventsEventIdModsModIdRewardsRoute:
      OrganizationSlugEventsEventIdModsModIdRewardsRoute,
    OrganizationSlugEventsEventIdModsModIdStorytellerRoute:
      OrganizationSlugEventsEventIdModsModIdStorytellerRoute,
    OrganizationSlugEventsEventIdModsModIdIndexRoute:
      OrganizationSlugEventsEventIdModsModIdIndexRoute,
  }

const OrganizationSlugEventsEventIdModsModIdRouteRouteWithChildren =
  OrganizationSlugEventsEventIdModsModIdRouteRoute._addFileChildren(
    OrganizationSlugEventsEventIdModsModIdRouteRouteChildren,
  )

interface OrganizationSlugEventsEventIdRouteRouteChildren {
  OrganizationSlugEventsEventIdSplatRoute: typeof OrganizationSlugEventsEventIdSplatRoute
  OrganizationSlugEventsEventIdBasicsRoute: typeof OrganizationSlugEventsEventIdBasicsRoute
  OrganizationSlugEventsEventIdCheckoutRoute: typeof OrganizationSlugEventsEventIdCheckoutRoute
  OrganizationSlugEventsEventIdLogisticsRoute: typeof OrganizationSlugEventsEventIdLogisticsRoute
  OrganizationSlugEventsEventIdPrintLedgerRoute: typeof OrganizationSlugEventsEventIdPrintLedgerRoute
  OrganizationSlugEventsEventIdPrintoutsRoute: typeof OrganizationSlugEventsEventIdPrintoutsRoute
  OrganizationSlugEventsEventIdSheetsRoute: typeof OrganizationSlugEventsEventIdSheetsRoute
  OrganizationSlugEventsEventIdShiftsRoute: typeof OrganizationSlugEventsEventIdShiftsRoute
  OrganizationSlugEventsEventIdTicketsRoute: typeof OrganizationSlugEventsEventIdTicketsRoute
  OrganizationSlugEventsEventIdTransactions_auditRoute: typeof OrganizationSlugEventsEventIdTransactions_auditRoute
  OrganizationSlugEventsEventIdWar_roomRoute: typeof OrganizationSlugEventsEventIdWar_roomRoute
  OrganizationSlugEventsEventIdIndexRoute: typeof OrganizationSlugEventsEventIdIndexRoute
  OrganizationSlugEventsEventIdModsModIdRouteRoute: typeof OrganizationSlugEventsEventIdModsModIdRouteRouteWithChildren
  OrganizationSlugEventsEventIdBlueprintsSplatRoute: typeof OrganizationSlugEventsEventIdBlueprintsSplatRoute
  OrganizationSlugEventsEventIdModsIndexRoute: typeof OrganizationSlugEventsEventIdModsIndexRoute
}

const OrganizationSlugEventsEventIdRouteRouteChildren: OrganizationSlugEventsEventIdRouteRouteChildren =
  {
    OrganizationSlugEventsEventIdSplatRoute:
      OrganizationSlugEventsEventIdSplatRoute,
    OrganizationSlugEventsEventIdBasicsRoute:
      OrganizationSlugEventsEventIdBasicsRoute,
    OrganizationSlugEventsEventIdCheckoutRoute:
      OrganizationSlugEventsEventIdCheckoutRoute,
    OrganizationSlugEventsEventIdLogisticsRoute:
      OrganizationSlugEventsEventIdLogisticsRoute,
    OrganizationSlugEventsEventIdPrintLedgerRoute:
      OrganizationSlugEventsEventIdPrintLedgerRoute,
    OrganizationSlugEventsEventIdPrintoutsRoute:
      OrganizationSlugEventsEventIdPrintoutsRoute,
    OrganizationSlugEventsEventIdSheetsRoute:
      OrganizationSlugEventsEventIdSheetsRoute,
    OrganizationSlugEventsEventIdShiftsRoute:
      OrganizationSlugEventsEventIdShiftsRoute,
    OrganizationSlugEventsEventIdTicketsRoute:
      OrganizationSlugEventsEventIdTicketsRoute,
    OrganizationSlugEventsEventIdTransactions_auditRoute:
      OrganizationSlugEventsEventIdTransactions_auditRoute,
    OrganizationSlugEventsEventIdWar_roomRoute:
      OrganizationSlugEventsEventIdWar_roomRoute,
    OrganizationSlugEventsEventIdIndexRoute:
      OrganizationSlugEventsEventIdIndexRoute,
    OrganizationSlugEventsEventIdModsModIdRouteRoute:
      OrganizationSlugEventsEventIdModsModIdRouteRouteWithChildren,
    OrganizationSlugEventsEventIdBlueprintsSplatRoute:
      OrganizationSlugEventsEventIdBlueprintsSplatRoute,
    OrganizationSlugEventsEventIdModsIndexRoute:
      OrganizationSlugEventsEventIdModsIndexRoute,
  }

const OrganizationSlugEventsEventIdRouteRouteWithChildren =
  OrganizationSlugEventsEventIdRouteRoute._addFileChildren(
    OrganizationSlugEventsEventIdRouteRouteChildren,
  )

interface OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteChildren {
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute
}

const OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteChildren: OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteChildren =
  {
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdSplatRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdInventoryRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdJournalRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdPrintoutRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdXp_auditRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdIndexRoute,
  }

const OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteWithChildren =
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute._addFileChildren(
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteChildren,
  )

interface OrganizationSlugPlayersPlayerIdRouteRouteChildren {
  OrganizationSlugPlayersPlayerIdSplatRoute: typeof OrganizationSlugPlayersPlayerIdSplatRoute
  OrganizationSlugPlayersPlayerIdAttendanceRoute: typeof OrganizationSlugPlayersPlayerIdAttendanceRoute
  OrganizationSlugPlayersPlayerIdCorrective_actionsRoute: typeof OrganizationSlugPlayersPlayerIdCorrective_actionsRoute
  OrganizationSlugPlayersPlayerIdMembershipsRoute: typeof OrganizationSlugPlayersPlayerIdMembershipsRoute
  OrganizationSlugPlayersPlayerIdPerksRoute: typeof OrganizationSlugPlayersPlayerIdPerksRoute
  OrganizationSlugPlayersPlayerIdReferralsRoute: typeof OrganizationSlugPlayersPlayerIdReferralsRoute
  OrganizationSlugPlayersPlayerIdIndexRoute: typeof OrganizationSlugPlayersPlayerIdIndexRoute
  OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute: typeof OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteWithChildren
  OrganizationSlugPlayersPlayerIdCharactersIndexRoute: typeof OrganizationSlugPlayersPlayerIdCharactersIndexRoute
}

const OrganizationSlugPlayersPlayerIdRouteRouteChildren: OrganizationSlugPlayersPlayerIdRouteRouteChildren =
  {
    OrganizationSlugPlayersPlayerIdSplatRoute:
      OrganizationSlugPlayersPlayerIdSplatRoute,
    OrganizationSlugPlayersPlayerIdAttendanceRoute:
      OrganizationSlugPlayersPlayerIdAttendanceRoute,
    OrganizationSlugPlayersPlayerIdCorrective_actionsRoute:
      OrganizationSlugPlayersPlayerIdCorrective_actionsRoute,
    OrganizationSlugPlayersPlayerIdMembershipsRoute:
      OrganizationSlugPlayersPlayerIdMembershipsRoute,
    OrganizationSlugPlayersPlayerIdPerksRoute:
      OrganizationSlugPlayersPlayerIdPerksRoute,
    OrganizationSlugPlayersPlayerIdReferralsRoute:
      OrganizationSlugPlayersPlayerIdReferralsRoute,
    OrganizationSlugPlayersPlayerIdIndexRoute:
      OrganizationSlugPlayersPlayerIdIndexRoute,
    OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRoute:
      OrganizationSlugPlayersPlayerIdCharactersCharacterIdRouteRouteWithChildren,
    OrganizationSlugPlayersPlayerIdCharactersIndexRoute:
      OrganizationSlugPlayersPlayerIdCharactersIndexRoute,
  }

const OrganizationSlugPlayersPlayerIdRouteRouteWithChildren =
  OrganizationSlugPlayersPlayerIdRouteRoute._addFileChildren(
    OrganizationSlugPlayersPlayerIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRoute: CalendarRoute,
  OrganizationSlugIndexRoute: OrganizationSlugIndexRoute,
  OrganizationSlugBranchesBranchIdRouteRoute:
    OrganizationSlugBranchesBranchIdRouteRouteWithChildren,
  OrganizationSlugEventsEventIdRouteRoute:
    OrganizationSlugEventsEventIdRouteRouteWithChildren,
  OrganizationSlugPlayersPlayerIdRouteRoute:
    OrganizationSlugPlayersPlayerIdRouteRouteWithChildren,
  OrganizationSlugBlueprintsSplatRoute: OrganizationSlugBlueprintsSplatRoute,
  OrganizationSlugStatisticsSplatRoute: OrganizationSlugStatisticsSplatRoute,
  OrganizationSlugCharactersIndexRoute: OrganizationSlugCharactersIndexRoute,
  OrganizationSlugEventsIndexRoute: OrganizationSlugEventsIndexRoute,
  OrganizationSlugInvoiceIndexRoute: OrganizationSlugInvoiceIndexRoute,
  OrganizationSlugReportsIndexRoute: OrganizationSlugReportsIndexRoute,
  OrganizationSlugMechanicsDiseasesSplatRoute:
    OrganizationSlugMechanicsDiseasesSplatRoute,
  OrganizationSlugMechanicsFaithsSplatRoute:
    OrganizationSlugMechanicsFaithsSplatRoute,
  OrganizationSlugMechanicsSocietiesSplatRoute:
    OrganizationSlugMechanicsSocietiesSplatRoute,
  OrganizationSlugMechanicsThreatsSplatRoute:
    OrganizationSlugMechanicsThreatsSplatRoute,
  OrganizationSlugReportsCapsBranchIdRoute:
    OrganizationSlugReportsCapsBranchIdRoute,
  OrganizationSlugReportsCorrective_actionsBranchIdRoute:
    OrganizationSlugReportsCorrective_actionsBranchIdRoute,
  OrganizationSlugBlueprintsTabularIndexRoute:
    OrganizationSlugBlueprintsTabularIndexRoute,
  OrganizationSlugMechanicsDice_rollerIndexRoute:
    OrganizationSlugMechanicsDice_rollerIndexRoute,
  OrganizationSlugReportsCapsIndexRoute: OrganizationSlugReportsCapsIndexRoute,
  OrganizationSlugReportsCharacter_retirementsIndexRoute:
    OrganizationSlugReportsCharacter_retirementsIndexRoute,
  OrganizationSlugReportsCorrective_actionsIndexRoute:
    OrganizationSlugReportsCorrective_actionsIndexRoute,
  OrganizationSlugReportsGrowthIndexRoute:
    OrganizationSlugReportsGrowthIndexRoute,
  OrganizationSlugReportsMembershipsIndexRoute:
    OrganizationSlugReportsMembershipsIndexRoute,
  OrganizationSlugReportsPlayersIndexRoute:
    OrganizationSlugReportsPlayersIndexRoute,
  OrganizationSlugSettingsSpecial_datesIndexRoute:
    OrganizationSlugSettingsSpecial_datesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
